import {observer} from "mobx-react";
import {ModalDialog, Page, PageContentTitle} from "../../ui";
import {DialogStore, growlStore, scaCreateStore, scaCustomerStore} from "../../../store";
import {useState} from "react";
import {useNavigate} from "react-router";
import {ScaMainForm} from "./ScaMainForm";

const ScaCreatePage = observer(function ScaCreatePage() {
    const navigate = useNavigate()
    const [cancelDialog] = useState(new DialogStore())
    const saving = scaCreateStore.creating
    const formValid = scaCreateStore.valid
    const formDirty = scaCreateStore.dirty
    const display = 'Sicherheitscodes erfassen'

    return <Page
        breadcrumb={[
            {
                link: '/sca',
                label: `Sicherheitscodes`
            },
            {
                link: '/sca/create',
                label: display
            },
        ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        scaCreateStore.reset()
                        cancelDialog.dialogOpen = false
                        navigate('/sca')
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${saving ? 'is-loading' : ''}`,
                    disabled: !(formDirty && formValid) || saving,
                    action: async () => {
                        const id = await scaCreateStore.create()
                        if (!id) {
                            growlStore.add({
                                message: 'Die Erfassung konnte nicht gespeichert werden',
                                autoclose: 1000,
                                cls:'is-danger',
                                closable: true
                            })
                            return
                        }
                        scaCreateStore.reset()
                        growlStore.add({
                            message: 'Die Erfassung wurde gespeichert',
                            autoclose: 1000,
                            closable: true
                        })
                        navigate(`/sca/${id}`)
                    }
                }, {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: !scaCreateStore.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <ScaMainForm
            disabled={scaCreateStore.formDisabled}
            customers={scaCustomerStore.items}
            validation={scaCreateStore.formValidation}
            value={scaCreateStore.formData}
            onChange={v => scaCreateStore.formData = v}
            onBlur={async () => await scaCreateStore.validate()}
            onSearchCustomer={async v => await scaCustomerStore.search(v)}
        />
    </Page>
})

export {
    ScaCreatePage
}
